interface BoardingElements {
  landing: Pick<HTMLElement, 'hidden'>;
  screen: { classList: Pick<DOMTokenList, 'add' | 'remove'> };
}

/** Prewarming owns graphics, not departure. Keep the live roster/countdown
 * visible and the full-size canvas measurable until Go actually departs. */
export class RunBoardingPresentation {
  private phase: 'idle' | 'countdown' | 'boarding' | 'active' = 'idle';

  public constructor(private readonly elements: BoardingElements,
    private readonly hideCrew: () => void) {}

  public begin(countdown: boolean): void {
    this.elements.screen.classList.remove('is-active', 'is-loading', 'is-preparing');
    this.phase = countdown ? 'countdown' : 'boarding';
    if (countdown) {
      this.elements.landing.hidden = false;
      this.elements.screen.classList.add('is-preparing');
    } else this.showBoarding();
  }

  public depart(): void {
    if (this.phase !== 'countdown') return;
    this.phase = 'boarding';
    this.showBoarding();
  }

  public activate(): boolean {
    if (this.phase !== 'boarding') return false;
    this.phase = 'active';
    this.elements.screen.classList.remove('is-loading', 'is-preparing');
    this.elements.screen.classList.add('is-active');
    return true;
  }

  public reset(): void {
    this.phase = 'idle';
    this.elements.screen.classList.remove('is-active', 'is-loading', 'is-preparing');
    this.elements.landing.hidden = false;
  }

  private showBoarding(): void {
    this.hideCrew();
    this.elements.landing.hidden = true;
    this.elements.screen.classList.remove('is-preparing');
    this.elements.screen.classList.add('is-loading');
  }
}
